import { z } from 'zod';

// Coerce 'true' to true
export const booleanSchema = z.preprocess(
  (value) => ((typeof value === 'string' && value.toLowerCase() === 'true') || value === true ? true : false),
  z.boolean(),
);
